import { createContext, type FC, type ReactNode, useContext } from 'react';
import type { DocumentContext } from '@ContractBuilder/utils/get-document-context';
import type { ResourceBlock } from '@domain/schemas/contract.schema';
import type { BlockSegment } from '@features/page-split';
import type { GeneratedBlockFlags } from '@hooks/use-block-flags-generator';
import type { BlockMentionValues } from '@root/helpers/blocks/get-block-mention-values';

export type BlockFlagsContextType = GeneratedBlockFlags & {
  isHighlighted?: boolean;
  isLoading?: boolean;
  mentionValues: BlockMentionValues;
  block: ResourceBlock;
  context: DocumentContext;
  segment?: BlockSegment;
};

export const BlockFlagsContext = createContext<BlockFlagsContextType | null>(null);

export const useBlockFlags = () => {
  const context = useContext(BlockFlagsContext);

  if (!context) {
    throw new Error(`"BlockFlagsProvider" must be present in React DOM tree.`);
  }

  return context;
};

interface BlockFlagsProviderProps {
  value: BlockFlagsContextType;
  children?: ReactNode;
}

export const BlockFlagsProvider: FC<BlockFlagsProviderProps> = ({ children, value }) => (
  <BlockFlagsContext.Provider value={value}>{children}</BlockFlagsContext.Provider>
);
